import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LoanResolutionSchema = withDefaults({
  type: 'loan-resolution',
  objectExtensions: ['loan-resolution'],
  fields: [
    {
      kind: 'attribute',
      name: 'domain',
    },
    {
      kind: 'attribute',
      name: 'rawText',
    },
    {
      kind: 'attribute',
      name: 'resolutionSource',
    },
    {
      kind: 'attribute',
      name: 'adminAction',
    },
    {
      kind: 'attribute',
      name: 'resolvableType',
    },
    {
      kind: 'attribute',
      name: 'resolvableId',
    },
    {
      kind: 'attribute',
      name: 'resolvableName',
    },
    {
      kind: 'attribute',
      name: 'resolvableLabel',
    },
    {
      kind: 'attribute',
      name: 'matchesCount',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
  ],
});

export default LoanResolutionSchema;
